import { render, staticRenderFns } from "./ebookEdit.vue?vue&type=template&id=c2bae6f8&scoped=true&"
import script from "./ebookEdit.vue?vue&type=script&lang=js&"
export * from "./ebookEdit.vue?vue&type=script&lang=js&"
import style0 from "./ebookEdit.vue?vue&type=style&index=0&id=c2bae6f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bae6f8",
  null
  
)

export default component.exports